<template>
    <b-overlay
        variant="white"
        :show="show"
        spinner-variant="primary"
        blur="0"
        opacity=".85"
        rounded="sm"
    >
        <slot></slot>
        <template #overlay><slot name="overlay"/></template>
    </b-overlay>
</template>

<script>
import {BOverlay} from 'bootstrap-vue'
export default {
    components: {BOverlay},
    props: {
        show: {
            default: true
        }
    }
}
</script>
